import { useSSOProfileForm, type SSOProfileFormSchema } from '@frontend/forms';
import { Button, TextInput, YStack, type MissingFieldsData } from '@frontend/web-react';

type CompleteProfileFormProps = {
  isLoading?: boolean;
  onSubmit: (data: MissingFieldsData) => void;
};

export const CompleteProfileForm = ({ isLoading, onSubmit }: CompleteProfileFormProps) => {
  const { dirty, getControl, handleSubmit, isValid } = useSSOProfileForm({
    onSubmit: (values: SSOProfileFormSchema) => {
      onSubmit({
        firstName: values.firstName,
        lastName: values.lastName,
      });
    },
  });

  return (
    <form className="gap-y-md flex w-full max-w-md flex-col" noValidate onSubmit={handleSubmit}>
      <TextInput
        {...getControl('firstName')}
        autoComplete="given-name"
        label="First Name"
        placeholder="Enter your first name"
      />
      <TextInput
        {...getControl('lastName')}
        autoComplete="family-name"
        label="Last Name"
        placeholder="Enter your last name"
      />
      <YStack className="mt-md">
        <Button disabled={!isValid || !dirty || isLoading} fullWidth isForm isLoading={isLoading}>
          Continue
        </Button>
      </YStack>
    </form>
  );
};
